"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractPrice = function (_BaseClass) {
  _inherits(ContractPrice, _BaseClass);

  /**
   * Preisstufe
   * @type {string}
   */
  function ContractPrice() {
    _classCallCheck(this, ContractPrice);

    var _this = _possibleConstructorReturn(this, (ContractPrice.__proto__ || Object.getPrototypeOf(ContractPrice)).call(this));

    _this.PriceLevel = "";
    _this.Price = 0;
    return _this;
  }
  /**
   * Preis
   * @type {integer}
   */


  return ContractPrice;
}(_BaseClass3.default);

exports.default = ContractPrice;